import React from 'react';
import { Smile } from 'lucide-react';

export default function MessageList({ messages, userId, onReact }) {
  const isOwn = (msg) => msg.sender_id === userId;

  if (messages.length === 0) {
    return <div className="text-center py-20 text-sm" style={{color:'var(--text-muted)'}}>Envoyez le premier message !</div>;
  }

  return (
    <>
      {messages.filter(m => !m.deleted).map(msg => (
        <div key={msg.id} className={`flex ${isOwn(msg) ? 'justify-end' : 'justify-start'}`}>
          <div className="group relative max-w-[65%]">
            <div
              className={`px-4 py-2.5 rounded-2xl text-sm leading-relaxed ${
                isOwn(msg)
                  ? 'bg-gradient-to-r from-brand-purple to-brand-violet text-white rounded-br-md'
                  : 'rounded-bl-md'
              }`}
              style={!isOwn(msg) ? {background:'var(--bg-input)', color:'var(--text-primary)'} : undefined}
            >
              {msg.content || msg.text}
            </div>
            <div className={`text-[10px] mt-1 ${isOwn(msg) ? 'text-right' : 'text-left'}`} style={{color:'var(--text-faint)'}}>
              {new Date(msg.created_at || msg.timestamp).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
              {isOwn(msg) && (msg.read ? ' \u2713\u2713' : ' \u2713')}
            </div>
            {msg.reactions?.length > 0 && (
              <div className="flex gap-1 mt-1">
                {msg.reactions.map(r => (
                  <span key={`${msg.id}-${r.emoji}-${r.user_id || 'self'}`} className="text-xs rounded-full px-1.5 py-0.5" style={{background:'var(--bg-card)'}}>{r.emoji}</span>
                ))}
              </div>
            )}
            {onReact && (
              <button
                onClick={() => onReact(msg.id, '\u2764\ufe0f')}
                className="absolute -top-2 right-0 opacity-0 group-hover:opacity-100 transition-opacity rounded-full p-1"
                style={{background:'var(--bg-secondary)'}}
              >
                <Smile size={14} style={{color:'var(--text-muted)'}} />
              </button>
            )}
          </div>
        </div>
      ))}
    </>
  );
}
